<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container">
    <div class="row">
      <div class="col-sm-12 px-0">
        <select :required="required==true" class="form-control" v-bind:id="'select_assigned_user_' +  getId()" v-on:change="onChange" v-select>
          <option value="" style="">{{$t('select_user')}}</option>
          <option v-for="user in users" v-bind:value="user.UserName">
            {{ user.Name }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>


  let message = "";
  var users = [];
  var placeholder = "";

  export default {
    name: "user-selector",
    props: {
      loadDataOnInit: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        message: "",
        users,
        placeholder
      };
    },
    methods: {
      onChange() {
        this.$emit('event-change-member', $('#select_assigned_user_' + this.getId()).val());
        this.$emit('change', $('#select_assigned_user_' + this.getId()).val());
      },
      selectUser(selected) {
        $("#select_assigned_user_" + this.getId()).val(selected);
        $("#select_assigned_user_" + this.getId()).trigger('change');
      },
      getId() {
        return this._uid;
      },
      fetchReloadData() {
        this.loadMembers();
      },
      loadMembers() {
        try {          
          var url = '/api/Users/v1';
          this.$http.get(url).then(async response => {
            this.users = response.data;            
            //console.log(this.users);
            if (this.users !== null && this.users.length > 0) {
              this.users = this.users.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }           
            $('#select_assigned_user_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      getData() {
        return this.users;
      }
    },
    watch: {
    },
    mounted() {
      if (this.loadDataOnInit == true) {
        this.loadMembers();
      }
      $("#select_assigned_user_" + this.getId()).change(this.onChange);
      this.placeholder = this.$t('select_user');

    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/user/user-selector.vue